import requester from "api/requester"
import { transformObjectKeysToSnakeCase } from "api/converter"
import {
  ICreateSchedulePayload,
  IUpdateSchedulePayload,
} from "model/food/types/schedulePayloads.types"

const getScheduleFormDataPayload = (payload: ICreateSchedulePayload) => {
  const snakeCasePayload = transformObjectKeysToSnakeCase(payload)

  const formData = new FormData()

  Object.keys(snakeCasePayload).forEach((key) => {
    const data = (snakeCasePayload as any)[key]
    if (data === undefined || data === null || data === "") return

    if (key === "ingredients" || key === "units" || key === "days_of_week") {
      formData.append(
        key,
        new Blob([JSON.stringify(data)], {
          type: "application/json",
        }),
      )
    } else {
      formData.append(key, data)
    }
  })

  return formData
}

const scheduleAPI = {
  getSchedules: () => {
    return requester.get(`/schedules`)
  },

  getSchedule: (scheduleId: string) => {
    return requester.get(`/schedules/${scheduleId}`)
  },

  createSchedule: (payload: ICreateSchedulePayload) => {
    const formData = getScheduleFormDataPayload(payload)
    return requester.post("/schedules", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  },

  updateSchedule: ({ payload, scheduleId }: IUpdateSchedulePayload) => {
    const formData = getScheduleFormDataPayload(payload)
    return requester.put(`/schedules/${scheduleId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
  },

  deleteSchedule: (scheduleId: string) => {
    return requester.delete(`/schedules/${scheduleId}`)
  },

  stopSchedule: ({
    scheduleId,
    fromDate,
  }: {
    scheduleId: string
    fromDate: string
  }) => {
    return requester.post(`/schedules/${scheduleId}/stop`, {
      fromDate,
    })
  },
}

export default scheduleAPI
